var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isOwnerWorkspace)?_c('div',[_c('BankInformation')],1):_c('div',[_c('p',{staticClass:"fs-16 fw-500 text-center my-5"},[_vm._v("Bạn không có quyền truy cập")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }